module.exports = __webpack_public_path__ + "img/corrugatedBox17.8f1ef3be.jpg";